<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12" sm="4" lg="3" xl="2">
        <div v-if="module.mainImage && module.mainImage.thumbnail">
          <img :src="module.mainImage.thumbnail.url">
        </div>
        <div v-else-if="module.mainImage">
          <img :src="module.mainImage.url">
        </div>
      </b-col>
      <b-col cols="12" sm="8" lg="9" xl="10">
        <span class="name">
          {{ module.name }}
        </span>
        <br>
        <span class="description">
          {{ module.description }}
        </span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    module: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
@import 'node_modules/bootstrap/scss/bootstrap-grid.scss';

img {
  width: 100%;
  height: auto;
}

@include media-breakpoint-down(xs) {
  img {
    margin-bottom: $spacing-xs;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/modules/row.vue